import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getReferrals, getLinkReferral, deleteReferral } from "../../../actions/admin/referral";
import AdminPage from "../_components/AdminPage";
import AdminCreateButton from "../_components/AdminCreateButton";
import AdminTable from "../_components/AdminTable";
import AdminDeleteModal from "../_components/AdminDeleteModal";
import ReferralItem from "./ReferralItem";

const TABLE_COLUMNS = [
  { key: "no", title: "#", width: "tw:w-[60px] tw:rounded-tl-[5px]", skeleton: "narrow" },
  { key: "name", title: "Company Name", width: "tw:w-[240px]" },
  { key: "website", title: "Website", width: "tw:w-[280px]" },
  { key: "code", title: "Code", width: "tw:w-[180px]" },
  { key: "status", title: "Status", width: "tw:w-[160px]", skeleton: "badge" },
  { key: "createdOn", title: "Added Date", width: "tw:w-[180px]" },
  { key: "action", title: "Action", width: "tw:w-[160px] tw:rounded-tr-[5px]", sticky: true, align: "center" },
];

const ReferralList = () => {
  const referral = useSelector((state) => state.referral);
  const { loading, referrals } = referral;
  const [delId, setDelId] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getReferrals());
  }, [dispatch]);

  const removeReferral = () => {
    dispatch(deleteReferral(delId));
    setDelId(null);
  };

  const copyLinkReferral = async (id) => {
    const getLink = await getLinkReferral(id);

    if (getLink.status === 200) {
      navigator.clipboard
        .writeText(getLink.data.link)
        .then(() => {
          alert("Referral link copied to clipboard");
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
        });
    }
  };

  return (
    <AdminPage title="Referral List" actions={<AdminCreateButton to="/admin/addreferral" label="Add Referral" />}>
      <AdminDeleteModal
        show={!!delId}
        title="Delete this referral?"
        message="This cannot be undone."
        onCancel={() => setDelId(null)}
        onConfirm={removeReferral}
      />

      <AdminTable
        columns={TABLE_COLUMNS}
        minWidth={1260}
        loading={loading}
        skeletonRowCount={8}
        isEmpty={!referrals?.length}
        emptyText="No referrals found."
      >
        {referrals?.map((item, index) => (
          <ReferralItem
            key={item._id}
            referral={item}
            count={index}
            removeReferral={setDelId}
            copyLinkReferral={copyLinkReferral}
          />
        ))}
      </AdminTable>
    </AdminPage>
  );
};

export default ReferralList;
